export const USER_CACHE_EVENT = 'user-cache-updated'

export function getUserCachedData() {
    try {
        const storedUser = localStorage.getItem('user')
        if (!storedUser) return null

        const parsedUser = JSON.parse(storedUser)
        return parsedUser && typeof parsedUser === 'object' && !Array.isArray(parsedUser)
            ? parsedUser
            : null
    } catch {
        localStorage.removeItem('user')
        return null
    }
}

export function checkIsLogged() {
    const userData = getUserCachedData()
    const isLogged = !!userData?.token
    return isLogged;
}

export function cleanUserToken() {
    localStorage.removeItem('user')
}

export function performLogin(data) {
    const user = JSON.stringify(data)
    localStorage.setItem('user', user)
}

/**
 * Atualiza o cache do usuário com dados frescos do backend
 * Usado para sincronizar permissões sem fazer logout
 */
export function updateUserCachedData(userData) {
    const currentUser = getUserCachedData()
    const updatedUser = { ...currentUser, ...userData }
    const serialized = JSON.stringify(updatedUser)
    // Sem mudança real, não grava nem avisa ninguém (evita re-render em cadeia)
    if (localStorage.getItem('user') === serialized) return updatedUser
    localStorage.setItem('user', serialized)
    // Avisa quem depende das permissões (ex.: Router) para recalcular sem recarregar a página
    try { window.dispatchEvent(new Event(USER_CACHE_EVENT)) } catch (e) {}
    return updatedUser
}

/**
 * Obtém o role do usuário do cache
 */
export function getUserRole() {
    const user = getUserCachedData()
    return user?.userRole || user?.role || user?.user_role || 'associated_lawyer'
}
